export default __webpack_public_path__ + "static/media/snow.2af78fa5.png";